import { useAuth } from 'src/components/AuthProvider/AuthProvider';

interface UseBalanceAccountInfoReturn {
  isBalanceAccount: boolean;
  externalBalanceBuyerId: string | null;
}

export const useBalanceAccountInfo = (): UseBalanceAccountInfoReturn => {
  const { corpData } = useAuth();

  const externalBalanceBuyerId = corpData?.externalId || null;
  const isBalanceAccount = !!externalBalanceBuyerId;

  return {
    isBalanceAccount,
    externalBalanceBuyerId,
  };
};
